/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // ステッパー（マイナス）での数量指定
  document.querySelectorAll("button[data-stepper-minus]").forEach((elem, index) => {
    elem.addEventListener('click', event => {
      event.preventDefault();
      var val = Number(elem.parentNode.querySelector('input[type="number"]').value);
      var min =  elem.parentNode.querySelector('input[type="number"]').min;
      val -= 1;
      if (val < min) {
        val = min;
      }
     elem.parentNode.querySelector('input[type="number"]').value = val;
    });
  });

  // ステッパー（プラス）での数量指定
  document.querySelectorAll("button[data-stepper-plus]").forEach((elem, index) => {
    elem.addEventListener('click', event => {
      event.preventDefault();
      var val = Number(elem.parentNode.querySelector('input[type="number"]').value);
      var max =  elem.parentNode.querySelector('input[type="number"]').max;
      val += 1;
      if (val > max) {
        val = max;
      }
      elem.parentNode.querySelector('input[type="number"]').value = val;
    });
  });
  
  window.addEventListener('DOMContentLoaded', function(){
    window.addEventListener('scroll', function(){
      if (window.scrollY > 100) {
        document.querySelector(".header__desktop__upper").classList.add('sticky');
        document.querySelector(".header__mobile").classList.add('sticky');        
      } else {
        document.querySelector(".header__desktop__upper").classList.remove('sticky');
        document.querySelector(".header__mobile").classList.remove('sticky');      
      }
    });

    document.querySelectorAll(".cart_coupon_code_list .coupon_code").forEach((elem, index) => {
      elem.addEventListener('click', event => {
        const couponInput = document.querySelector(".dcbInput");
        elem.classList.add("is-selected");
        document.querySelector(".coupon_howto_message").classList.remove('hidden');

        var codes = [];
        if (couponInput.value) {
          codes = couponInput.value.split(",");
        }
        if (codes.includes(elem.dataset.couponCode) == false) {
          codes.push(elem.dataset.couponCode);
          couponInput.value = codes.join(",");
        }
      });
    });

    document.querySelectorAll(".dcbButton").forEach((elem, index) => {
      elem.addEventListener('click', event => {
        document.querySelector(".dcbButton").classList.add('is-used');
        document.querySelector(".coupon_message").textContent = "クーポンを適用した金額は決済画面で反映されます。";

        // 使ったクーポンの一覧を表示する
        document.querySelectorAll(".cart_coupon_code_list .coupon_code.is-selected").forEach((elem, index) => {
          console.log(elem.dataset.couponCode);
          var usedCoupon = document.querySelector(`.used_coupon_code[data-coupon-code=${elem.dataset.couponCode}]`);
          usedCoupon.classList.remove('hidden');
        });
      });
    });
    document.querySelectorAll(".used_coupon_list .resultCodeRemove").forEach((elem, index) => {
      elem.addEventListener('click', event => {
        const code = elem.dataset.couponCode;
        document.querySelector(`.used_coupon_code[data-coupon-code=${code}]`).classList.add("hidden");
        document.querySelector(`.coupon_code[data-coupon-code=${code}]`).classList.remove("is-selected");
      });
    });


    document.querySelectorAll(".footer__block__title").forEach((elem, index) => {
      elem.addEventListener('click', event => {
        if(window.parent.screen.width < 750) {
          if (elem.parentNode.classList.contains("open")) {
            elem.parentNode.classList.remove('open');
          } else {
            elem.parentNode.classList.add("open");
          }
        }
      });
    });

    // Judge.me レビュー調整（ニックネームのラベルを非表示にする）
    document.querySelectorAll('.jdgm-rev__cf-ans__title').forEach((elem, index) => {
      if (elem.innerText == "お名前:" || elem.innerText == "ニックネーム:") {
        elem.parentNode.classList.add("jdgm-nickname");
      }
    });

    // フォームバリデーション（初期化処理）
    const validationForms = Array.from(document.querySelectorAll('.js-validation-form'));
    for (const validationForm of validationForms) {
      const submitBtn = validationForm.querySelector('.js-submit-btn');
      const customError = validationForm.querySelector('.js-custom-error');
      const customErrorContainer = validationForm.querySelector('.js-custom-error-container');

      if (!submitBtn || !customError || !customErrorContainer) continue;
      submitBtn.addEventListener('click', (event) => {
        event.preventDefault();

        // 既存のエラー文言を削除
        customError.classList.remove('is-active');
        while (customErrorContainer.firstChild) {
          customErrorContainer.removeChild(customErrorContainer.firstChild);
        }

        // バリデーションを実行
        let errors = [];
        const formClassList = validationForm.classList;

        if (formClassList.contains('js-validate-password')) {
          const passwordErrors = validatePassword(validationForm);
          errors = errors.concat(passwordErrors);
        }

        // エラー表示　or フォーム送信
        if (errors.length > 0) {
          customError.classList.add('is-active');
          setErrorInfo(errors, validationForm, customErrorContainer);
        } else {
          validationForm.submit();
        }
      });
    }
  });

  /**
   * フォームバリデーションで使用する関数
   * @param {Element} form
   * @returns {Array} errors
   */
  const validatePassword = (form) => {
    let errors = [];
    const passwordInput = form.querySelector('.js-password-input');

    if (!passwordInput) return errors;
    const password = passwordInput.value;

    // 文字数チェック
    if (password.length < 5) {
      errors.push({
        "type": "PASSWORD_LENGTH",
        "message": "パスワードは最低でも5文字以上です",
        "targetSelector": ".js-password-input",
      });
    }

    return errors;
  }

  /**
   * フォームバリデーションでエラーメッセージを表示する
   * @param {Array} errors エラーの情報がまとまった配列
   * @param {Element} form
   * @param {Element} errorContainer
   * @returns {Void}
   */
  const setErrorInfo = (errors, form, errorContainer) => {
    const fragment = document.createDocumentFragment();

    errors.forEach((error) => {
      const errorItem = document.createElement('li');
      errorItem.textContent = error.message;
      fragment.appendChild(errorItem);

      const target = form.querySelector(error.targetSelector);
      if (target) {
        target.classList.add('error');
      }
    });

    errorContainer.appendChild(fragment);
  }


  // ハンバーガー調整に伴い追加スクリプト 202309
  document.addEventListener("DOMContentLoaded", () => {
    //  detailsを使用したアコーディオン
    setUpAccordion();

    // モーダルライブラリ初期化処理
    MicroModal.init({
      disableScroll: true,
    });
  });
  
  const setUpAccordion = () => {
    const details = document.querySelectorAll(".js-details");
    const RUNNING_VALUE = "running";
    const IS_OPENED_CLASS = "is-opened";
  
    const animTiming = {
      duration: 300,
      easing: "ease-out"
    };

    const closingAnimKeyframes = (content) => [
      {
        height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
        opacity: 1,
      }, {
        height: 0,
        opacity: 0,
      }
    ];

    const openingAnimKeyframes = (content) => [
      {
        height: 0,
        opacity: 0,
      }, {
        height: content.offsetHeight + 'px',
        opacity: 1,
      }
    ];

    details.forEach((element) => {
      const summary = element.querySelector(".js-summary");
      const content = element.querySelector(".js-content");
  
      summary.addEventListener("click", (event) => {
        event.preventDefault();
  
        // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
        if (element.dataset.animStatus === RUNNING_VALUE) return;
  
        if (element.open) {
          element.classList.toggle(IS_OPENED_CLASS);
  
          const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
          element.dataset.animStatus = RUNNING_VALUE;
  
          closingAnim.onfinish = () => {
            element.removeAttribute("open");
            element.dataset.animStatus = "";
          };
        } else {
          element.setAttribute("open", "true");
          element.classList.toggle(IS_OPENED_CLASS);
  
          const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
          element.dataset.animStatus = RUNNING_VALUE;
  
          openingAnim.onfinish = () => {
            element.dataset.animStatus = "";
          };
        }
      });
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


const validationCustomerForms = () => {
  let errElem, errMessage;
  document.querySelectorAll('input[required]').forEach((elem) => {
    let isError;
    switch(elem.type) {
      case "checkbox":
        isError = (!elem.checked);
        break;
      default:
        isError = (elem.value == null || elem.value == "");
        break;
    }
    if (!errElem && isError) {
      errElem = elem;
      errMessage = "必須項目「{{target}}」がありません。";
    }
  });
  // 必須項目チェック
  document.querySelectorAll("select[required]").forEach((elem) => {
    if (!errElem && (elem.value == null || elem.value == "")) {
      errElem = elem;
      errMessage = "必須項目「{{target}}」がありません。";
    }
  });
  // バリデーションチェック
  document.querySelectorAll("[pattern]").forEach((elem) => {
    const re = new RegExp(elem.getAttribute("pattern"));
    if (!errElem && !(elem.value == "" || elem.value == null) && !re.test(elem.value)) {
      errElem = elem;
      errMessage = "「{{target}}」にエラーがあります。";
    }
  });

  if (errElem) {
    const parentLabel = errElem.parentNode.querySelector('label');
    alert(errMessage.replace("{{target}}", parentLabel ? parentLabel.innerText : errElem.name));
    return false;
  }
  return true;
};